import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Image from "material-ui-image";
import { Trans } from "@lingui/macro";
import { Hidden, Typography } from "@material-ui/core";
import PrivacyPolicy from "../privacy-policy";
import CookiesInfo from "../../containers/cookies/cookies-info";
import Link from "../link";
import config from "../../config";
import theme from "../../theme";

const useStyles = makeStyles((th) => ({
  footer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    backgroundColor: th.palette.black,
    position: "relative",
    [th.breakpoints.down("xs")]: {
      height: "auto",
    },
  },
  footerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
    width: "100%",
    padding: th.spacing(2),
    [th.breakpoints.down("xs")]: {
      flexDirection: "column",
      width: "100%",
      height: "100%",
    },
  },
  footerInfo: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    [th.breakpoints.down("xs")]: {
      justifyContent: "center",
      flexDirection: "column",
      marginBottom: theme.spacing(2),
      gap: 16,
    },
  },
  link: {
    marginRight: theme.spacing(3 / 2),
    cursor: "pointer",
  },
  linkContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    [th.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  linkRow: {
    display: "flex",
    flexDirection: "row",
    [th.breakpoints.down("xs")]: {
      paddingBottom: theme.spacing(1),
    },
  },
  footerMobile: {
    backgroundColor: th.palette.black,
    height: "0px",
    [th.breakpoints.down("xs")]: {
      height: "60px",
    },
  },
}));

function Footer() {
  const classes = useStyles(theme);
  const flagCygnetPartnership = useSelector(
    (state) => state.misc.featureFlags["flag.exp.show_cygnet_west_partnership"],
  );
  const flagAboutUs = useSelector((state) => state.misc.featureFlags["flag.ops.show_about_info"]);
  const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);
  const [openCookiesInfo, setOpenCookiesInfo] = useState(false);

  return (
    <Box className={classes.footer}>
      <PrivacyPolicy open={openPrivacyPolicy} onClose={() => setOpenPrivacyPolicy(false)} />
      <CookiesInfo open={openCookiesInfo} onClose={() => setOpenCookiesInfo(false)} />
      <Box className={classes.footerContainer}>
        <Box className={classes.footerInfo}>
          <Link to="/home">
            <Image
              src={config.LOGO_LIGHT}
              imageStyle={{ height: 35, width: 90 }}
              style={{
                height: 35,
                width: 90,
                paddingTop: 0,
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(1),
                backgroundColor: theme.palette.black,
              }}
            />
          </Link>

          {flagCygnetPartnership && (
            <>
              <Box display="flex" flexDirection="row" alignItems="center" ml={2}>
                <Typography variant="body1" style={{ color: theme.palette.white, marginRight: theme.spacing(1 / 2) }}>
                  <Trans>In partnership with</Trans>
                </Typography>
                <Typography variant="body1" style={{ color: theme.palette.white, fontWeight: "bold" }}>
                  Cygnet West
                </Typography>
              </Box>
              <Hidden smDown>
                <Box display="flex" height="35px" width="1px" bgcolor={theme.palette.white} ml={2} />
              </Hidden>
            </>
          )}

          <Box display="flex" flexDirection="row" alignItems="center" ml={2}>
            <Typography variant="body1" style={{ color: theme.palette.white }}>
              <Trans>powered by</Trans>
            </Typography>
            <a href="https://crenex.io/" target="_blank" rel="noopener noreferrer">
              <Typography
                variant="body1"
                style={{ color: theme.palette.white, fontWeight: "bold", marginLeft: theme.spacing(1 / 2) }}
              >
                <Trans>crenex.io</Trans>
              </Typography>
            </a>
          </Box>
        </Box>
        <Box className={classes.linkContainer}>
          <Box className={classes.linkRow}>
            {flagAboutUs && (
              <Link to="/about-us" className={classes.link}>
                <Typography variant="h6" style={{ color: theme.palette.white }}>
                  <Trans>Sobre Nosotros</Trans>
                </Typography>
              </Link>
            )}

            {!!config.HELP && (
              <Link to={config.HELP} className={classes.link}>
                <Typography variant="h6" style={{ color: theme.palette.white }}>
                  <Trans>Ayuda</Trans>
                </Typography>
              </Link>
            )}

            {!!config.PRIVACY_POLICY && (
              <Box onClick={() => setOpenPrivacyPolicy(true)} className={classes.link}>
                <Typography variant="h6" style={{ color: theme.palette.white }}>
                  <Trans>Política de privacidad</Trans>
                </Typography>
              </Box>
            )}

            <Box onClick={() => setOpenCookiesInfo(true)} className={classes.link}>
              <Typography variant="h6" style={{ color: theme.palette.white }}>
                <Trans>Cookie Policy</Trans>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
